export default __webpack_public_path__ + "static/media/Participation.ed8e5537.mp4";